<script lang="ts">
  import type { Atelier } from '../../stores/creation.svelte'

  let { atelier }: { atelier: Atelier } = $props()

  const noms = $derived(atelier.referentiel.categories_armes)
  const offertes = $derived(atelier.etat.maitrises_offertes)
  const solde = $derived(atelier.etat.maitrises)

  /**
   * Ce que la Classe a déjà donné : les huit offertes moins ce qui reste
   * proposable. Le Technodiacre reçoit Mains de Dieu, qui n'est pas dans les
   * huit — elle apparaît donc en plus.
   */
  const octroyees = $derived(
    atelier.referentiel.bareme.maitrises_offertes.filter((id) => !offertes.includes(id)),
  )
</script>

<p class="chapo">
  Une seule Maîtrise de Niveau 1, à prendre dans la liste fermée que le livre
  offre à la Création. Celles que la Classe donne en dotation s'y ajoutent — et
  ne sont pas reproposées.
</p>

<div class="cartouche">
  <div class="bandeau">Maîtrise de départ</div>
  <div class="corps">
    <div class="cartes">
      {#each offertes as id (id)}
    {@const prise = atelier.feuille.maitrises.includes(id)}
    {@const complet = solde.faits >= solde.attendus}
    <button
      type="button"
      class="carte"
      class:active={prise}
      disabled={!prise && complet}
      onclick={() => atelier.basculerMaitrise(id)}
    >
          {noms[id] ?? id}
        </button>
      {/each}
    </div>
  </div>
</div>

{#if octroyees.length > 0}
  <div class="cartouche">
    <div class="bandeau">Déjà données par la Classe</div>
    <div class="corps">
      <div class="cartes">
        {#each octroyees as id (id)}
          <span class="carte donnee">{noms[id] ?? id}</span>
        {/each}
      </div>
    </div>
  </div>
{/if}

<style>
  .chapo {
    color: var(--ink-soft);
    max-width: 62ch;
    margin: 0 0 calc(var(--pas) * 4);
  }
  .cartes {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));
    gap: calc(var(--pas) * 2);
  }
  .carte {
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--r);
    padding: calc(var(--pas) * 3);
    color: var(--ink);
    text-align: left;
    cursor: pointer;
    font: inherit;
    font-size: 0.9rem;
  }
  .carte:hover:not(:disabled):not(.donnee) {
    border-color: var(--line-fort);
  }
  .carte.active {
    border-color: var(--accent);
    box-shadow: inset 3px 0 0 var(--accent);
  }
  .carte:disabled {
    opacity: 0.4;
    cursor: default;
  }
  .donnee {
    cursor: default;
    color: var(--ink-soft);
    border-style: dashed;
  }
</style>
